<template>
  <div>
    <p v-if="displayType === 'long'">
      Holdings concentration displays the percent of the overall portfolio for each equity, fixed income, and cash/cash equivalent security in the portfolio, whether held directly or through a fund. Securities that constitute at least 0.001% of a fund are included in the concentration aggregation. Positions held in different accounts are aggregated together for this analysis. NPORT SEC filings are used to determine holdings concentration data within funds and is updated on a quarterly basis. Unmatched holdings (e.g. private equity securities) are displayed using the symbol uploaded by the user.
    </p>

    <p v-else>
      Holdings concentration displays the percent of the overall portfolio for each equity, fixed income, and cash/cash equivalent security in the portfolio, whether held directly or contained within pooled investment assets. Individual securities are aggregated across all assets contained within the portfolio. NPORT SEC filings are used to determine holdings concentration data within funds and is updated on a quarterly basis.
    </p>
  </div>
</template>


<script>
export default {
  name: 'ConcentrationMethodology',
  props: ['displayType', 'portfolio', 'benchmark'],
};
</script>
